import type { ComponentWhereInput } from '@gql/graphql';

export function getComponentSearchWhere(
    searchTerm: string,
): ComponentWhereInput | undefined {
    const search = searchTerm.trim();
    if (!search) return undefined;

    return {
        or: [
            { nameContainsFold: search },
            { hasComponentVendorWith: [{ nameContainsFold: search }] },
        ],
    };
}
